// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { hjCookieConverter, hjGetCookie, hjSetCookie } from '@hotjar/webapp/utils/cookies';

export interface UtmParamTypes {
  // eslint-disable-next-line camelcase
  utm_source?: string | null;
  // eslint-disable-next-line camelcase
  utm_campaign?: string | null;
  // eslint-disable-next-line camelcase
  utm_medium?: string | null;
  // eslint-disable-next-line camelcase
  utm_term?: string | null;
  // eslint-disable-next-line camelcase
  utm_content?: string | null;
  adgroupid?: string | null;
  keyword?: string | null;
  matchtype?: string | null;
  device?: string | null;
  gclid?: string | null;
}

const utmParamNames = [
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_term',
  'utm_content',
  'adgroupid',
  'keyword',
  'matchtype',
  'device',
  'gclid',
];

/**
 * Simple JSON key comparator, independent of the ordering of the keys.
 * @param a
 * @param b
 */
export const isEqualsJson = (
  a: Record<string, unknown> | null,
  b: Record<string, unknown> | null,
): boolean => {
  if (a == null || b == null) {
    return false;
  }
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  return aKeys.length === bKeys.length && Object.keys(a).every((key) => a[key] === b[key]);
};

/**
 * Check UTM params in the URL and validates them against the existing ones if they exist
 */
export const validateAndProcessUtmParams = (): void => {
  let storedUtmParams = null;
  if (hjGetCookie('utm_params') != null) {
    const decoded = hjCookieConverter.decode(hjGetCookie('utm_params'));
    // Wrapped in try/catch in case cookie value is not valid JSON format
    try {
      storedUtmParams = JSON.parse(decoded);
    } catch (e) {
      storedUtmParams = null;
    }
  }

  const queryParamsAvailable = new URLSearchParams(window.location.search);
  const utmParams: UtmParamTypes = utmParamNames.reduce((acc, paramName) => {
    const param = queryParamsAvailable.get(paramName);
    if (param != null) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      acc[paramName] = param;
    }
    return acc;
  }, {});

  // At least one of the basic utm parameters need to be present for us to store the rest too...
  const hasSomeBasicUtmParam: boolean =
    Boolean(utmParams.utm_source) ||
    utmParams.utm_campaign ||
    utmParams.utm_medium ||
    utmParams.utm_content;

  // ... and being different from previously stored cookie so we don't extend expiration date on each access
  const hasSameParams: boolean = isEqualsJson(storedUtmParams, utmParams);
  if (hasSomeBasicUtmParam && !hasSameParams) {
    hjSetCookie(
      'utm_params',
      hjCookieConverter.encode(JSON.stringify(utmParams)),
      30,
      'hotjar.com',
    );
  }
};
